<template>
    <!-- 列表无数据显示暂无数据 -->
    <div class="list-wrap" v-loading="loading">
        <slot></slot>
        <el-empty
            v-show="isEmptyList"
            :description="
                isSearch ? '抱歉，没有查询到您需要的信息' : '暂无数据'
            "
        >
            <template slot="image">
                <img
                    class="image"
                    src="@/assets/images/no-search-data.png"
                    alt=""
                />
            </template>
        </el-empty>
    </div>
</template>
<script>
export default {
    props: {
        isEmptyList: {
            default: false,
            type: Boolean,
        },
        isSearch: {
            default: false,
            type: Boolean,
        },
    },
};
</script>
<style lang="less" scoped>
.el-empty__description {
    margin-top: 28px;
}
.el-empty__description p {
    font-size: 16px;
    color: #747e88;
}
.image {
    width: 88px;
}
</style>